const stories = [
    {
        link: 'https://www.youtube.com/embed/xMxY9zGSDxs?si=U_oEYiAXhL_piL87',
        name: 'Ferry',
        age: '28',
        job: 'ondernemer',
    },
    {
        link: 'https://www.youtube.com/embed/LuSOuWhegkM?si=A2NONSVmevvAyfEa',
        name: 'Jeroen',
        age: '45',
        job: 'Packaging Expert Campina',
    },
    {
        link: 'https://www.youtube.com/embed/yj8tZ5mQ7I0?si=lKxReL2xLBTS0gXb',
        name: 'Maaike',
        age: '30',
        job: 'kapster',
    },
    {
        link: 'https://www.youtube.com/embed/UAgIZI6LKZY?si=JVLNpUjdPxKHovqP',
        name: 'Renee',
        age: '27',
        job: 'paardentandarts',
    },
];

export default ({ classNames = "" }) => {
    return (
        <div
            className={`relative xs:pt-8 sm:pt-8 md:pt-16 lg:pt-16 ${classNames}`}
        >
            <div className="absolute inset-0">
                <div className="bg-black h-1/3 sm:h-2/3" />
            </div>
            <div className="relative max-w-7xl mx-auto">
                <div className="text-center">
                    <h2 className="block text-white font-custom italic font-bold uppercase xl:inline  xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                        Luister naar hun verhaal
                    </h2>
                </div>
                <div className="lg:mt-4 md:mt-4 sm:mt-4 xs:mt-4 max-w-lg mx-auto grid gap-5 lg:grid-cols-1 lg:max-w-none">
                    {stories.map((story, key) => (
                        <div
                            className="relative lg:p-32 sm:p-8 xs:p-8 lg:h-[850px] xs:h-[100%] md:h-[750px]"
                            id="more-info"
                        >
                            <h3 className="text-2xl font-extrabold tracking-tight text-white sm:text-4xl">
                                {story.name}
                            </h3>
                            <p className="mt-3 text-lg leading-6 text-white">
                                {story.age} jaar - {story.job}
                            </p>
                            <iframe
                                width="100%"
                                height="100%"
                                src={story.link}    
                                title="WE ARE - your physical and mental personal training - reviews"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
